import { ElementRenderer } from 'alkali'

export default ElementRenderer
